import { render, staticRenderFns } from "./StudentsLogin.vue?vue&type=template&id=13f2d0f6&"
import script from "./StudentsLogin.vue?vue&type=script&lang=js&"
export * from "./StudentsLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports